﻿import React from 'react';
import { VerticalLink } from 'components/navigation/VerticalLink';
import PropTypes from 'prop-types';

import 'components/navigation/Navigation.css';

export function VerticalLinkGroup(
    {
        exactRouteMatch = true,
        links
    }
) {
    return (
        <div className="bp6-tabs bp6-vertical">
            <ul className="bp6-tab-list" role="tablist">
                {links.map((l, index) => {
                    return <VerticalLink key={index} location={l.location} title={l.title} exactRouteMatch={exactRouteMatch} externalLink={l.externalLink}></VerticalLink>;
                })}
            </ul>
        </div>
    );
}

VerticalLinkGroup.propTypes = {
    links: PropTypes.array.isRequired,
    exactRouteMatch: PropTypes.bool,
}; 